import "react-loading-skeleton/dist/skeleton.css";

import { useTranslation } from "react-i18next";
import { excludePaths } from "~/constants/paths";
import { useAccount } from "~/hooks/useAccount";
import { useMemo, useState } from "react";
import CountdownTimer from "~/components/ui/Countdown";
import dayjs from "dayjs";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";

import * as S from "./TryForFreeBanner.style";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import Skeleton from "react-loading-skeleton";
import { SVG } from "~/components/ui/SVG";
import promotionCollage from "~/assets/png/alidrop-promo.png";

const ALIDROP_REGISTER_URL =
  "https://app.alidrop.co/register?utm_source=dropshiptool&utm_medium=promotionbanner";

export const TryForFreeBanner = () => {
  const { t } = useTranslation();
  const { account, isLoading } = useAccount();
  const [isTimerDone, setIsTimerDone] = useState(false);

  // New accounts only: visible from signup until created_at + 24 hours
  const targetDate = useMemo(
    () => dayjs(account?.created_at).add(24, "hours").toDate(),
    [account?.created_at]
  );

  const isWithinFirst24Hours = useMemo(() => {
    if (!account?.created_at) return false;
    return targetDate.getTime() > Date.now();
  }, [account?.created_at, targetDate]);

  const shouldHideBanner =
    DISABLE_PAYMENTS ||
    isTimerDone ||
    !isWithinFirst24Hours ||
    excludePaths.some((path) => window.location.pathname.includes(path));

  if (shouldHideBanner) {
    return null;
  }

  if (!account || isLoading) {
    return (
      <S.SkeletonContainer>
        <Skeleton height="158px" width="100%" />
      </S.SkeletonContainer>
    );
  }

  return (
    <S.BannerContainer>
      <S.ContentColumn>
        <S.Title>{t("banner.title")}</S.Title>

        <S.FooterContainer>
          <S.ClaimOfferButton
            href={ALIDROP_REGISTER_URL}
            target="_blank"
            rel="noopener noreferrer">
            {t("banner.button_text")}
            <SVG icon={faArrowRight} size="sm" />
          </S.ClaimOfferButton>

          <CountdownTimer
            key={window.location.pathname}
            targetDate={targetDate}
            bgColor="borderSecondary"
            numberColor="text"
            textColor="textSecondary"
            textSize="11px"
            width="57px"
            height="50px"
            numberSize="18px"
            hoursKey="hours"
            minutesKey="minutes"
            secondsKey="seconds"
            showHours
            dots
            dotsColor="#081F40"
            dotsHeight={1.5}
            callback={() => {
              setIsTimerDone(true);
            }}
          />
        </S.FooterContainer>
      </S.ContentColumn>

      <S.CollageContainer>
        <S.CollageImage src={promotionCollage} alt="" />
      </S.CollageContainer>
    </S.BannerContainer>
  );
};
